import { render, staticRenderFns } from "./LoanableEditPricingParameters.vue?vue&type=template&id=74f02d07"
import script from "./LoanableEditPricingParameters.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoanableEditPricingParameters.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LoanableEditPricingParameters.vue?vue&type=style&index=0&id=74f02d07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports